var render = function render(){var _vm=this,_c=_vm._self._c;return _c('CardLayout',[_c('NotificationCardHeader',{attrs:{"card-icon":_vm.cardIcon,"card-title":_vm.cardTitle,"card-subtitle":_vm.cardSubtitle}}),_c('ButtonFullWidth',{on:{"click":_vm.buttonEvent}},[_c('div',{attrs:{"slot":"text"},slot:"text"},[_vm._v(_vm._s(_vm.buttonText))])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }